import { Card, Divider, Eyebrow, Surface, Text } from "@/components/ui";
import { Classification } from "@/types/food-classification";
import { foodClassificationMapper } from "@/types/food-classification-mapper";

type SuitableDietsGridProps = {
  suitableDiets?: string[];
};

/**
 * Dietary classifications heading + responsive grid of food classification
 * cards. Markup shared by ItemModalContent and OptionCard's OptionModal.
 * Renders nothing when there are no diets.
 */
export function SuitableDietsGrid({ suitableDiets }: SuitableDietsGridProps) {
  if (!suitableDiets || suitableDiets.length === 0) return null;

  return (
    <div className="mt-2">
      <div className="space-y-4">
        <div className="flex flex-col gap-2">
          <Eyebrow>Classificações Alimentares</Eyebrow>
          <Divider />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {suitableDiets.map((diet, index) => {
            const food = foodClassificationMapper[diet as Classification];
            if (!food) return null;

            return (
              <Card
                key={`${diet}-${index}`}
                variant="outline"
                padding="sm"
                className="flex items-center gap-3"
              >
                <Surface surface="card" className="flex-shrink-0 flex items-center justify-center rounded-full shadow-card">
                  <img src={food.img ?? ""} alt={food.title ?? "Classificação"} className="w-16 h-16" />
                </Surface>
                <div className="flex-1 min-w-0">
                  <Text size="sm" weight="medium" tone="default" truncate>
                    {food.title}
                  </Text>
                  <Text size="xs" tone="muted" clamp={2} leading="relaxed">
                    {food.description}
                  </Text>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
}
